import extendNode from '../extendNode.mjs'
import useCategoryNode from '../_CATEGORY/useCategoryNode.jsx'
import meta from './metaIsrfBiz.mjs'

export default () => {
    const CategoryNode = useCategoryNode()

    return extendNode(CategoryNode, {
        ...meta,

        canMountType(map, node, type) {
            return /^(URL)$/.test(type)
        },

        menuItemsInsertCommon(map, node) {
            return [
                {type: 'URL'},
            ]
        },
    })
}
